module.exports = __webpack_public_path__ + "img/vdara8.aa976d60.jpg";